@if (!isStreaming && !streamingMessage && !loadingStream) {
  <button class="btn-gray bg-lugano-red hover:bg-lugano-red-dark" (click)="onStreamVr()">
    <span>Stream View</span>
  </button>
}
@if (!isStreaming && loadingStream) {
  <button class="btn-gray bg-lugano-red-dark pointer-events-none">
    <span>Loading...</span>
  </button>
}
@if (isStreaming || streamingMessage) {
  <button class="btn-gray bg-lugano-red pointer-events-none">
    <span>Streaming view</span>
  </button>
}
